import {
  Box,
  List,
  ListItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
} from '@mui/material';

import { LinkStyled } from 'theSource/components';

export const BenefitDocumentsListStyled = styled(List)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
});

export const BenefitDocumentsListItemStyled = styled(ListItem)(({ theme }) => ({
  alignItems: 'flex-start',
  display: 'flex',
  gap: theme.spacing(4),
  padding: theme.spacing(4, 0),

  '&:not(:last-child)': {
    borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
  },
}));

export const BenefitDocumentsListItemTextWrapperStyled = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0,

    [`${LinkStyled}`]: {
      wordWrap: 'break-word',
    },
  })
);

export const LinkWrapperStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
});

export const AccordionStyled = styled(Accordion)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '&:before': {
    display: 'none',
  },
  '& .MuiButtonBase-root': {
    padding: 0,
  },
  '.MuiCollapse-vertical': {
    paddingLeft: theme.spacing(2),
  },
  '& li': {
    padding: 0,
  },
  '& li:not(:last-child)': {
    borderBottom: 0,
  },
  '&:not(:last-child)': {
    borderBottom: 0,
  },
}));

export const AccordionSummaryStyled = styled(AccordionSummary)(({ theme }) => ({
  color: theme.palette.primaryDark.main,
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(3),
  },
}));

export const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
  padding: 0,
  'li ~ li': {
    marginTop: theme.spacing(3),
  },
}));
